export class AzureMssqlSnapshotProperties {
    'sku';
    'adminLogin';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sku",
            "baseName": "sku",
            "type": "string",
            "format": ""
        },
        {
            "name": "adminLogin",
            "baseName": "adminLogin",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureMssqlSnapshotProperties.attributeTypeMap;
    }
    constructor() {
    }
}
